import { ApolloClient, InMemoryCache } from '@apollo/client';

import { getEnvValue } from 'configs/app/utils';

export const graphqlNftRedemptionV3GraphqlClient = new ApolloClient({
  uri: getEnvValue('NEXT_PUBLIC_GRAPHQL_NFT_REDEMPTION_V3_ENDPOINT'),
  cache: new InMemoryCache(),
});
